import styles from './vehicle_brand_model.module.scss';
import {Alignment} from '../../enums/alignment.ts';
import React, {CSSProperties} from 'react';
import {classNames} from '../../support/classnames.ts';

export enum VehicleBrandModelSize {
    Default,
    Small,
}
interface OwnProps {
    brand: string | null;
    model: string | null;
    children?: React.ReactNode;
    alignment?: Alignment;
    size?: VehicleBrandModelSize;
    style?: CSSProperties;
}

export function VehicleBrandModel({brand, model, children, alignment, size, style}: OwnProps) {
    return (
        <div
            style={style}
            className={classNames(styles.vehicle_brand_model, {
                [styles.align_left]: alignment === Alignment.Start,
                [styles.align_right]: alignment === Alignment.End,
                [styles.small]: size === VehicleBrandModelSize.Small,
            })}
        >
            <span className={styles.vehicle_brand_model__brand}>
                {brand ?? <span className={styles.placeholder} />}
            </span>
            <span className={styles.vehicle_brand_model__model}>
                {model ?? <span className={styles.placeholder} />}
            </span>

            {children && <span className={styles.vehicle_brand_model__children}>{children}</span>}
        </div>
    );
}
